import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Avatar,
  Button,
  Descriptions,
  Drawer,
} from 'antd';

import i18n from '../../config/i18n';
import defaultUserAvatarImage from '../../styles/images/no_testimonial_avatar_image.png';
import '../../styles/css/MedicalRecordPreview.css';

const styles = {
  drawer: {
    wrapper: {
      paddingTop: '72px',
    },
    body: {
      height: 'calc(100% - 105px)',
      padding: '0',
    },
  },
};


const MedicalRecordPreview = ({
  cancelText,
  okText,
  onCancel,
  onClose,
  onOk,
  medicalRecordDetail,
  visible,
}) => {
  const fields = [
    {
      label: i18n.t('id'),
      children: medicalRecordDetail.identification,
    },
    {
      label: i18n.t('name'),
      children: `${medicalRecordDetail.firstName} ${medicalRecordDetail.lastName}`,
    },
    {
      label: i18n.t('gender'),
      children: medicalRecordDetail.gender,
    },
    {
      label: i18n.t('d_o_b'),
      children: moment(medicalRecordDetail.dateOfBirth).format('YYYY-MM-DD'),
    },
    {
      label: i18n.t('email'),
      children: medicalRecordDetail.email,
    },
  ];

  return (
    <Drawer
      bodyStyle={styles.drawer.body}
      drawerStyle={styles.drawer.wrapper}
      onClose={onClose}
      title={
        <div className="medical-record-preview-title">
          {i18n.t('patientDetail')}
        </div>
      }
      visible={visible}
      width={300}
    >
      <div className="medical-record-preview-content">
        <div className="medical-record-preview-avatar-wrapper">
          <Avatar
            shape="square"
            size={210}
            src={defaultUserAvatarImage}
            srcSet={medicalRecordDetail.avatarUrl}
          />
        </div>
        <Descriptions
          bordered
          column={1}
          layout="vertical"
          size="small"
        >
          {
            fields.map(({ label, children }) => (
              <Descriptions.Item
                key={label}
                label={label}
              >
                {children}
              </Descriptions.Item>
            ))
          }
        </Descriptions>
      </div>
      <div className="medical-record-preview-button-wrapper">
        <Button
          block
          onClick={onCancel}
          className="medical-record-preview-button"
        >
          {cancelText}
        </Button>
        <Button
          block
          onClick={onOk}
          type="primary"
          className="medical-record-preview-button"
        >
          {okText}
        </Button>
      </div>
    </Drawer>
  );
};

MedicalRecordPreview.propTypes = {
  avatarUrl: PropTypes.string,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  onOk: PropTypes.func,
  medicalRecordDetail: PropTypes.shape({
    email: PropTypes.string,
    dateOfBirth: PropTypes.string,
    firstName: PropTypes.string,
    gender: PropTypes.string,
    identification: PropTypes.string,
    lastName: PropTypes.string,
  }),
  visible: PropTypes.bool,
};

MedicalRecordPreview.defaultProps = {
  avatarUrl: '',
  onCancel: () => {},
  onClose: () => {},
  onOk: () => {},
  medicalRecordDetail: {},
  visible: false,
};


export default MedicalRecordPreview;



// WEBPACK FOOTER //
// ./src/components/messaging/MedicalRecordPreview.js